import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { NewCertificateInterface } from "interfaces/Certificate";
import { SellerInterface } from "interfaces/Seller";
import { UserRoles } from "interfaces/UserRoles";

export interface fetchSellerArgument {
  id: string;
  endpoint?: UserRoles;
  isFetchingCustomers?: any
}

export interface createSellerArgument {
  endpoint?: UserRoles;
  seller: createSellerInterface;
}
export interface createSellerInterface {
  agent_id: string;
  eldat_reference_id: string;
  taxation_kind_id: string;
  certificates: createSellerCertificateInterface[];
}
export interface createSellerCertificateInterface extends NewCertificateInterface {
  "_destroy"?: boolean;
}

export interface SellerResponseInterface {
  data: SellerInterface & {
    errors?: {[key: string]: {
      [key: string]: {
        [key: string]: string[];
      }
    }};
  }
}
export interface SellerModifiedResponseInterface {
  data: {
    errors?: {
      agent_id?: string[];
      eldat_reference_id?: string[];
      taxation_kind_id?: string[];
      certificates?: {
        [key: string]: {
          valid_from?: string[];
          valid_until?: string[];
        }
      };
    }
  };
}


export function fetchSeller({ id, endpoint}: fetchSellerArgument): Promise<AxiosResponse<SellerResponseInterface, any>> {
  return axiosInstance.get(`${endpoint}/sellers/${id}`);
}

export function deleteSeller({ id, endpoint}: fetchSellerArgument): Promise<AxiosResponse<SellerResponseInterface, any>> {
  return axiosInstance.delete(`${endpoint}/sellers/${id}`);
}

export function fetchCreateSeller({endpoint, seller}: createSellerArgument): Promise<AxiosResponse<SellerModifiedResponseInterface, any>> {
  return axiosInstance.post(`${endpoint}/sellers`, seller);
}

// export function fetchSeller({ id, endpoint  }: fetchSellerArgument): Promise<AxiosResponse<SellerResponseInterface, any>> {
//   return axiosInstance.get(`${endpoint}/sellers/${id}`);
// }



// export function fetchSeller({ id, endpoint, isFetchingCustomers }: fetchSellerArgument): Promise<AxiosResponse<SellerResponseInterface, any>> {
//   let apiUrl;

//   if (endpoint === UserRoles.Agent) {
//     const currentURL = window.location.href;
// const isFetchingCustomers = currentURL.includes("agent/kundenliste");
//     if (isFetchingCustomers) {
//       apiUrl = `https://api.staging.holzfinder.de/agent/customers/${id}`;
      
//     } else {
//       apiUrl = `https://api.staging.holzfinder.de/agent/sellers/${id}`;
      
//     }
//   } else if (endpoint === UserRoles.Admin) {
//     apiUrl = `${endpoint}/sellers/${id}`;
//   } else {
//     // Handle the case when 'endpoint' is neither 'Agent' nor 'Admin'
//     return Promise.reject(new Error('Invalid endpoint'));
//   }

//   return axiosInstance.get(apiUrl);
// }
